import { equal, sort } from '@ember/object/computed';
import Controller from '@ember/controller';
import { computed, get } from '@ember/object';
import moment from 'moment';

export default Controller.extend({
  noDates: equal('model.length', 0),

  sixMonthsFromNow: computed(function () {
    return moment().add(6, 'months').toDate();
  }),

  upcomingDates: computed('model.[]', 'sixMonthsFromNow', function () {
    let sixMonthsFromNow = this.sixMonthsFromNow;
    return this.model.filter((record) => {
      return get(record, 'nextDate') <= sixMonthsFromNow;
    });
  }),

  sortUpcomingDatesBy: ['nextDate:asc'],
  sortedUpcomingDates: sort('upcomingDates', 'sortUpcomingDatesBy'),

  recentlyPassedDates: computed('model.[]', 'sixMonthsFromNow', function () {
    let sixMonthsFromNow = this.sixMonthsFromNow;
    return this.model.filter((record) => {
      return get(record, 'nextDate') > sixMonthsFromNow;
    });
  }),

  sortRecentlyPassedDatesBy: ['nextDate:desc'],
  sortedRecentlyPassedDates: sort(
    'recentlyPassedDates',
    'sortRecentlyPassedDatesBy',
  ),
});
